export default __webpack_public_path__ + "static/media/52.8ac5cfaa.jpeg";